import { createContext } from "react";

export const AuthContext = createContext({ profile: {}, assets: {} });
export const StoreContext = createContext({ models: [] });
